<template>
    <basic-modal @hide="close"
                 v-model="opened"
                 aria-label="Request an invite"
                 role="dialog"
    >
        <div slot="header">
            <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
            <h3 class="modal-title">Request an invite</h3>
        </div>
        <div class="row margin-15-bottom">
            <div class="col-xs-12">
                <i>
                    You can request an invite from this group admin to join this group and sign up to multi me if you
                    haven’t already.
                    <br><br>
                    Please read the groups ‘About Page’ membership information to see if you qualify to join this group.
                    If you send a request then please include a message to the admin that says who you are and why you
                    would like to join this group.
                </i>
            </div>
        </div>
        <div class="row margin-15-bottom">
            <div class="col-xs-12">
                <input
                        type="email"
                        ref="emailField"
                        required
                        v-model="email"
                        class="form-control"
                        placeholder="Your email"
                        aria-label="Your email"
                />
            </div>
        </div>
        <div class="row margin-15-bottom">
            <div class="col-xs-12">
                <textarea
                        class="form-control"
                        required
                        v-model="message"
                        name="message"
                        id="message"
                        rows="10"
                        placeholder="Message to Group Admin"
                ></textarea>
            </div>
        </div>
        <div slot="footer">
            <button type="button" @click="close" class="btn btn-mm  btn-primary">Cancel</button>
            <button type="button" @click="send" :disabled="!readyToSent" class="btn btn-mm  btn-green">
                Send Request
            </button>
        </div>
    </basic-modal>
</template>

<script>
    import BasicModal from "../../../../vue/common_components/BasicModal";
    import PopupPromiseMixin from "../../../../vue/mixins/PopupPromiseMixin";

    export default {
        name: "RequestInvitePopup",
        components: {BasicModal},
        mixins: [PopupPromiseMixin],
        data() {
            return {
                email: '',
                message: '',
            };
        },
        computed: {
            firstFocusEl() {
                return this.$refs.emailField;
            },
            readyToSent() {
                return this.email.length && this.message.length;
            }
        },
        methods: {
            send() {
                this.save({
                    message: this.message,
                    email: this.email,
                });
            }
        }
    };
</script>